var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Packet from '../Packets/Model';
var CollaboratorPacket = /** @class */ (function (_super) {
    __extends(CollaboratorPacket, _super);
    function CollaboratorPacket(props) {
        var _this = _super.call(this, props) || this;
        if (props.disabled_at) {
            _this.disabled_at = new Date(props.disabled_at);
        }
        _this.operatorName = props.operatorName;
        _this.operator_id = props.operator_id;
        return _this;
    }
    return CollaboratorPacket;
}(Packet));
export default CollaboratorPacket;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorPackets/Model.ts
// module id = 740
// module chunks = 0